import { OpaqueToken } from '@angular/core';
import { environment } from '../environments/environment';
import { IAppConfig } from './iapp.config';
export const apiUrl = environment.apiUrl;

export let APP_CONFIG = new OpaqueToken('app.config');

export const AppConfig: IAppConfig = {
  apiEndpoint: environment.apiEndpoint
};

export const apiUrlcommon = environment.apiUrlcommon;
export const setting_url_return = environment.setting_url_return;
export const main_site_root_url = environment.main_site_root_url;
export const bridgeUrl = environment.bridgeUrl;



// WEBPACK FOOTER //
// ./src/app/app.config.ts